import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function useMarketFarms() {
  const [farms, setFarms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchFarms = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/market/farms/`);
      setFarms(res.data);
    } catch (e) { /* not a producer or no profile */ }
    finally { setLoading(false); }
  }, []);

  const createFarm = useCallback(async (data) => {
    setSaving(true);
    try {
      const res = await axios.post(`${API}/market/farms/`, { ...data, hectares: data.hectares || null });
      setFarms(prev => [...prev, res.data]);
      return res.data;
    } finally { setSaving(false); }
  }, []);

  const updateFarm = useCallback(async (id, data) => {
    setSaving(true);
    try {
      const res = await axios.patch(`${API}/market/farms/${id}/`, { ...data, hectares: data.hectares || null });
      setFarms(prev => prev.map(f => f.id === id ? res.data : f));
      return res.data;
    } finally { setSaving(false); }
  }, []);

  const deleteFarm = useCallback(async (id) => {
    await axios.delete(`${API}/market/farms/${id}/`);
    setFarms(prev => prev.filter(f => f.id !== id));
  }, []);

  return { farms, loading, saving, fetchFarms, createFarm, updateFarm, deleteFarm };
}
